import { Table } from "react-bootstrap";
import { useState } from "react";

const MedicalRecordsTable = () => {
  const [openAccordion, setOpenAccordion] = useState(null);

  const records = [
    {
      id: "MR001",
      name: "Peanuts Allergy",
      text: "Peanuts Allergy",
      category: "Food",
      available: "ANTE-TETANUS (DOSE)",
      sold: "Reacts to any food or supplements",
      sales: "Mild",
    },
    {
      id: "MR002",
      name: "Dust Allergy",
      text: "Dust Allergy",
      category: "Environmental",
      available: "Antihistamine",
      sold: "Triggers sneezing and irritation",
      sales: "Moderate",
    },
  ];

  return (
    <Table responsive striped bordered hover className="mb-4 shadow-sm">
      <thead className="bg-primary text-white">
        <tr>
          <th>ID</th>
          <th>Allergy</th>
          <th>Category</th>
          <th>Severity</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {records.map((record, index) => (
          <>
            <tr key={index}>
              <td>{record.id}</td>
              <td>{record.name}</td>
              <td>{record.category}</td>
              <td>{record.sales}</td>
              <td>
                <button
                  className="btn btn-sm"
                  onClick={() => setOpenAccordion(openAccordion === index ? null : index)}
                >
                  {openAccordion === index ? <i className="ri-arrow-up-s-line"></i> : <i className="ri-arrow-down-s-line"></i>}
                </button>
              </td>
            </tr>

            {openAccordion === index && (
              <tr>
                <td colSpan="5">
                  <div className="p-3 rounded bg-light border mt-2">
                    <h6 className="mb-3">Details</h6>
                    <Table responsive size="sm" className="mb-0">
                      <thead>
                        <tr>
                          <th>Reaction</th>
                          <th>Drug</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{record.sold}</td>
                          <td>{record.available}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </td>
              </tr>
            )}
          </>
        ))}
      </tbody>
    </Table>
  );
};

export default MedicalRecordsTable;
